import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faBoltLightning, faBullseye, faCalendarDay, faChessBoard, faCloudArrowDown, faFilePdf, faFutbol, faMobile, faPeopleGroup, faShieldHalved, faSliders, faStopwatch, faTrophy, faTv } from "@fortawesome/pro-light-svg-icons";
import "./Landing.css";

type Props = {};
type State = {
	clockMinutes: number;
	clockSeconds: number;
};

export class Landing extends React.Component<Props, State> {

	clockInterval: any;

	constructor(props: Props) {
		super(props);
		this.state = { clockMinutes: 87, clockSeconds: 32 };
	}

	componentDidMount() {
		document.title = "Pitchbase — Football club management & live scoreboards";
		this.clockInterval = setInterval(() => this.tickClock(), 1000);
	}

	componentWillUnmount() {
		clearInterval(this.clockInterval);
	}

	tickClock() {
		let { clockMinutes, clockSeconds } = this.state;
		clockSeconds++;
		if (clockSeconds > 59) { clockSeconds = 0; clockMinutes++; }
		if (clockMinutes > 93) { clockMinutes = 87; clockSeconds = 32; }
		this.setState({ clockMinutes, clockSeconds });
	}

	render() {
		return (
			<div className="lp">
				<header className="lp-nav">
					<div className="lp-nav-inner">
						<a className="lp-brand" href="#top">
							<img alt="Pitchbase" src="/assets/pitchbase-icon.png"/>
							<span>Pitchbase</span>
						</a>
						<nav className="lp-nav-links">
							<a href="#features">Features</a>
							<a href="#how">How it works</a>
						</nav>
						<a className="lp-btn lp-btn-primary lp-nav-cta" href="mailto:hello@thepitchbase.app">Get in touch <FontAwesomeIcon icon={faArrowRight}/></a>
					</div>
				</header>

				<main id="top">
					<section className="lp-hero">
						<div className="lp-hero-copy">
							<span className="lp-chip"><FontAwesomeIcon icon={faBoltLightning}/> Club management, reimagined</span>
							<h1>Run your club<br/>like a <span className="lp-accent">pro</span>.</h1>
							<p>Pitchbase brings your whole matchday together — live LED scoreboard control with animated matchday graphics, touchline remote, formations, teamsheets, squads and sponsors — in one beautifully simple platform.</p>
							<div className="lp-hero-ctas">
								<a className="lp-btn lp-btn-primary" href="#features">Explore features <FontAwesomeIcon icon={faArrowRight}/></a>
								<a className="lp-btn lp-btn-ghost" href="mailto:hello@thepitchbase.app">Get in touch</a>
							</div>
							<span className="lp-hero-note">Powering matchdays at Scunthorpe United F.C.</span>
						</div>
						<div className="lp-hero-visual">
							<div className="lp-stage-glow"/>
							<div className="lp-board3d">
								<div className="lp-board">
									<div className="lp-board-screen" style={{ backgroundImage: `radial-gradient(120% 100% at 50% 0%, rgba(10, 18, 32, 0.25) 0%, rgba(4, 7, 14, 0.72) 75%), url("/assets/Background2627.jpg")` }}>
										<div className="lp-board-top">
											<span className="lp-live"><span className="lp-live-dot"/>LIVE</span>
											<span className="lp-clock">{this.state.clockMinutes}:{String(this.state.clockSeconds).padStart(2, "0")}</span>
											<span className="lp-half">2ND HALF</span>
										</div>
										<div className="lp-board-score">
											<div className="lp-board-side">
												<span className="lp-crest"><img alt="Scunthorpe United" src="/assets/Badge.png"/></span>
												<span className="lp-board-team">IRON</span>
											</div>
											<div className="lp-digits">
												<span className="lp-digit">4</span>
												<span className="lp-digit-sep">&ndash;</span>
												<span className="lp-digit lp-digit-away">0</span>
											</div>
											<div className="lp-board-side">
												<span className="lp-crest"><img alt="Visitors" src="/assets/pitchbase-icon.png"/></span>
												<span className="lp-board-team">VISITOR</span>
											</div>
										</div>
										<div className="lp-scorers">No.9 &nbsp;23&rsquo; 55&rsquo; &nbsp;&bull;&nbsp; No.7 &nbsp;41&rsquo; &nbsp;&bull;&nbsp; No.11 &nbsp;78&rsquo;</div>
										<div className="lp-ticker">
											<div className="lp-ticker-track">
												<span>&#9917; GOAL &mdash; No.11 78&rsquo; &nbsp;&bull;&nbsp; ATTENDANCE 8,412 &nbsp;&bull;&nbsp; SUB &mdash; ON 14 / OFF 10 &nbsp;&bull;&nbsp; UP THE IRON &nbsp;&bull;&nbsp; POWERED BY PITCHBASE &nbsp;&bull;&nbsp; </span>
												<span>&#9917; GOAL &mdash; No.11 78&rsquo; &nbsp;&bull;&nbsp; ATTENDANCE 8,412 &nbsp;&bull;&nbsp; SUB &mdash; ON 14 / OFF 10 &nbsp;&bull;&nbsp; UP THE IRON &nbsp;&bull;&nbsp; POWERED BY PITCHBASE &nbsp;&bull;&nbsp; </span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="lp-float lp-float-goal"><FontAwesomeIcon icon={faFutbol}/> GOAL &mdash; 78&rsquo; No.11</div>
							<div className="lp-float lp-float-sub"><FontAwesomeIcon icon={faStopwatch}/> SUB &mdash; 61&rsquo; ON 14 / OFF 10</div>
						</div>
					</section>

					<section className="lp-section" id="features">
						<h2>Everything your matchday needs</h2>
						<p className="lp-section-sub">From the boardroom to the touchline, Pitchbase covers the lot.</p>
						<div className="lp-grid">
							<div className="lp-card">
								<div className="lp-card-icon"><FontAwesomeIcon icon={faTv}/></div>
								<h3>Live Scoreboard</h3>
								<p>Drive your LED scoreboard in real time — scores, goals, cards, substitutions, sponsors and media, pixel-perfect on the big screen.</p>
							</div>
							<div className="lp-card">
								<div className="lp-card-icon"><FontAwesomeIcon icon={faMobile}/></div>
								<h3>Match Remote</h3>
								<p>Record goals, cards and subs from the touchline on any device. The scoreboard and match data update instantly.</p>
							</div>
							<div className="lp-card">
								<div className="lp-card-icon"><FontAwesomeIcon icon={faChessBoard}/></div>
								<h3>Formation Manager</h3>
								<p>Drag and drop your squad into any shape, save your favourite line-ups, and export matchday graphics with player photos.</p>
							</div>
							<div className="lp-card">
								<div className="lp-card-icon"><FontAwesomeIcon icon={faFilePdf}/></div>
								<h3>Teamsheets</h3>
								<p>One click turns a fixture into a print-ready A4 teamsheet — squads, officials, sponsors and club branding included.</p>
							</div>
							<div className="lp-card">
								<div className="lp-card-icon"><FontAwesomeIcon icon={faPeopleGroup}/></div>
								<h3>Squads &amp; Fixtures</h3>
								<p>Manage players, statuses and sponsors, import squads from world football data, and keep your season calendar in order.</p>
							</div>
							<div className="lp-card">
								<div className="lp-card-icon"><FontAwesomeIcon icon={faShieldHalved}/></div>
								<h3>Your Club, Your Brand</h3>
								<p>Badge, colours, socials and sponsors — Pitchbase wears your club&rsquo;s identity across every screen and export.</p>
							</div>
							<div className="lp-card">
								<div className="lp-card-icon"><FontAwesomeIcon icon={faBullseye}/></div>
								<h3>Shootouts &amp; Big Moments</h3>
								<p>Run penalty shootouts kick by kick on the big screen, and let goals, attendance and the half-time draw land with broadcast-style animation — every screen&rsquo;s motion is yours to switch on or off.</p>
							</div>
							<div className="lp-card">
								<div className="lp-card-icon"><FontAwesomeIcon icon={faTrophy}/></div>
								<h3>Scores From The Leagues</h3>
								<p>A rotating latest-scores display with club crests and live in-play statuses from the leagues you care about — with its own sponsor slot to sell.</p>
							</div>
							<div className="lp-card">
								<div className="lp-card-icon"><FontAwesomeIcon icon={faCloudArrowDown}/></div>
								<h3>A Fleet You Can Trust</h3>
								<p>Pair any number of boards with a simple code, see live previews, presence and software versions — and push updates to the stadium in one click.</p>
							</div>
						</div>
					</section>

					<section className="lp-section lp-how" id="how">
						<h2>Matchday in three steps</h2>
						<div className="lp-steps">
							<div className="lp-step">
								<span className="lp-step-num">1</span>
								<h3><FontAwesomeIcon icon={faSliders}/> Set up your club</h3>
								<p>Add your badge, colours and squad — or import players straight from league data.</p>
							</div>
							<div className="lp-step">
								<span className="lp-step-num">2</span>
								<h3><FontAwesomeIcon icon={faCalendarDay}/> Pick your matchday</h3>
								<p>Create the fixture, choose your formation and export the teamsheet.</p>
							</div>
							<div className="lp-step">
								<span className="lp-step-num">3</span>
								<h3><FontAwesomeIcon icon={faTv}/> Run the show</h3>
								<p>Control the scoreboard live from the remote while every stat records itself.</p>
							</div>
						</div>
					</section>

					<section className="lp-cta">
						<h2>Ready to run your club?</h2>
						<p>Pitchbase is rolling out to clubs now. Get in touch and we&rsquo;ll get you on the pitch.</p>
						<div className="lp-hero-ctas lp-cta-buttons">
							<a className="lp-btn lp-btn-primary" href="mailto:hello@thepitchbase.app">Get in touch <FontAwesomeIcon icon={faArrowRight}/></a>
						</div>
					</section>
				</main>

				<footer className="lp-footer">
					<div className="lp-footer-inner">
						<a className="lp-brand" href="#top">
							<img alt="Pitchbase" src="/assets/pitchbase-icon.png"/>
							<span>Pitchbase</span>
						</a>
						<span className="lp-footer-meta">
							<Link to="/privacy">Privacy</Link>
							<span>&copy; {new Date().getFullYear()} Pitchbase. All rights reserved.</span>
						</span>
					</div>
				</footer>
			</div>
		);
	}
}
